import { render, staticRenderFns } from "./Template5.vue?vue&type=template&id=724e15d7&scoped=true&"
import script from "./Template5.vue?vue&type=script&lang=js&"
export * from "./Template5.vue?vue&type=script&lang=js&"
import style0 from "./Template5.vue?vue&type=style&index=0&id=724e15d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724e15d7",
  null
  
)

export default component.exports